import axiosInstance from ".";

export const getWork = () => {
  return axiosInstance.get("/careers");
};

export const addWork= (data) => {
  return axiosInstance.post("/careers", data);
};

export const updateWork = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/careers/${id}`, payload);
};

export const addWorkItem = (data) => {
  const { id, ...rest } = data;
  return axiosInstance.post(`/careers/${id}/work-item`, rest);
}

export const getWorkByItem = (query) => {
  return axiosInstance.get(`/careers/${query?.queryKey?.[1]}/work-item/${query?.queryKey?.[2]}`);
};

export const updateWorkByItem = (data) => {
  const { id, itemId, ...payload } = data;
  return axiosInstance.put(`/careers/${id}/work-item/${itemId}`, payload);
};

export const deleteWorkItem = (data) => {
  const { id, itemId, ...payload } = data;
  return axiosInstance.delete(`/careers/${id}/work-item/${itemId}`, payload);
};